// keyboard support
export enum KeyboardKey {
  Space = ' ',
  Enter = 'Enter',
  Up = 'Up',
  Left = 'Left',
  Down = 'Down',
  Right = 'Right',
  ArrowUp = 'ArrowUp',
  ArrowLeft = 'ArrowLeft',
  ArrowDown = 'ArrowDown',
  ArrowRight = 'ArrowRight',
}
